export const USER_ROLES = Object.freeze({
  USER: "user",
  CREATOR: "creator",
  ADMIN: "admin",
  SUPERADMIN: "superadmin",
});

export const VALID_USER_ROLES = Object.freeze(Object.values(USER_ROLES));

export function normalizeRole(value) {
  const role = String(value || "").trim().toLowerCase();
  return VALID_USER_ROLES.includes(role) ? role : USER_ROLES.USER;
}

export function getUserRole(user = {}) {
  return normalizeRole(user?.role);
}

export function hasRole(user, role) {
  return getUserRole(user) === normalizeRole(role);
}

export function hasAdminRole(user) {
  const role = getUserRole(user);
  return role === USER_ROLES.ADMIN || role === USER_ROLES.SUPERADMIN;
}

export function hasSuperAdminRole(user) {
  return hasRole(user, USER_ROLES.SUPERADMIN);
}

export function isCreator(user) {
  return hasRole(user, USER_ROLES.CREATOR);
}
